import { render } from "./JavascriptTag.vue.js?vue&type=template&id=12dacaad&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JavascriptTag.vue?vue&type=template&id=12dacaad&scoped=true"
import script from "./JavascriptTag.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JavascriptTag.vue?vue&type=script&lang=js"
export * from "./JavascriptTag.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JavascriptTag.vue?vue&type=script&lang=js"

import "./JavascriptTag.vue.css?vue&type=style&index=0&id=12dacaad&scoped=true&lang=css!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JavascriptTag.vue?vue&type=style&index=0&id=12dacaad&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12dacaad"],['__file',"src/Web/scripts/pages/monetization/JavascriptTag.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12dacaad"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12dacaad', __exports__)) {
    api.reload('12dacaad', __exports__)
  }
  
  module.hot.accept("./JavascriptTag.vue.js?vue&type=template&id=12dacaad&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JavascriptTag.vue?vue&type=template&id=12dacaad&scoped=true", () => {
    api.rerender('12dacaad', render)
  })

}


export default __exports__